import AxiosWrapper from '@/helpers/axios-wrapper'


/**
 * @returns Promise
 */
export function list() {
    return AxiosWrapper('/teams/params/list/', {});
}

/**
 * @returns Promise
 */
export function detail() {
    return AxiosWrapper('/teams/params/detail/', {});
}

/**
 * @returns Promise
 */
export function remove(formData) {
    return AxiosWrapper('/teams/params/remove/', {headers: {"Content-Type": "multipart/form-data"}}, 'POST', formData);
}